export const SkillsData = [ 
    {
        label: "FRONT END",
        data: [
            {
                skillName: "HTML",
                percentage: "90",
            },
            {
                skillName: "CSS",
                percentage: "80",
            },
            {
                skillName: "BootStrap",
                percentage: "70",
            },
            {
                skillName: "JavaScript",
                percentage: "60",
            },
            {
                skillName: "React",
                percentage: "60",
            },
        ]
    },
    {
        label: "BACK END",
        data: [
            {
                skillName: "NodeJS",
                percentage: "50",
            },
            {
                skillName: "ExpressJs",
                percentage: "50",
            },
        ]
    },
    {
        label: "DATABASE",
        data: [
            {
                skillName: "SQL",
                percentage: "70",
            },
            {
                skillName: "MongoDB",
                percentage: "60",
            },
        ]
    },
];